import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var ConnectorAuthService = /** @class */ (function () {
    function ConnectorAuthService() {
        this.isLoggedIn = new BehaviorSubject(false);
        this.onsetExamDataDto = new BehaviorSubject(null);
    }
    ConnectorAuthService.prototype.login = function (onsetExamDataDto) {
        this.onsetExamDataDto.next(onsetExamDataDto);
        this.isLoggedIn.next(true);
    };
    ConnectorAuthService.ngInjectableDef = i0.defineInjectable({ factory: function ConnectorAuthService_Factory() { return new ConnectorAuthService(); }, token: ConnectorAuthService, providedIn: "root" });
    return ConnectorAuthService;
}());
export { ConnectorAuthService };
